import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  loader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    height: 'inherit',
    alignItems: 'center',
  },
  errorMessage: {
    fontSize: 15,
    letterSpacing: 0.35,
    color: theme.palette.grey[600],
  },
  investNowLayout: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    background: theme.palette.common.white,
    overflow: 'hidden',
    boxShadow: theme.shadows[1],
    borderRadius: 20,
    '@media (max-width: 1024px)': {
      display: 'block',
      position: 'relative',
    },
  },
  investNowLPopup: {
    width: '100%',
    height: '100%',
    display: 'flex',
    background: theme.palette.common.white,
    overflow: 'hidden',
    boxShadow: theme.shadows[1],
    borderRadius: 20,
    '@media (max-width: 1024px)': {
      display: 'block',
      position: 'relative',
    },
    '@media (max-width: 767px)': {
      borderRadius: 0,
    },
  },
  investNowLayoutLeft: {
    background: '#F8F8F8',
    flex: '0 0 auto',
    width: 278,
    overflow: 'hidden overlay',
    // boxShadow: theme.shadows[2],
    '@media (max-width: 1220px)': {
      width: 230,
    },
    '@media (max-width: 1024px)': {
      // position: 'sticky',
      // top: 0,
      // height: 70,
      // zIndex: 100,
      // margin: 0,
      // border: 0,
      overflow: 'hidden',
      width: '100%',
      padding: '30px 0 40px',
      background: theme.palette.primary.contrastText,
      // boxShadow: '0 1px 2px 0 rgba(32, 33, 36, 28%)',
    },
  },
  logoInBox: {
    padding: '43px 50px 43px',
    '@media (max-width: 1220px)': {
      padding: '43px 25px 43px',
    },
    '@media (max-width: 1024px)': {
      padding: '0 5% 50px',
    },
  },
  invLogoImg: {
    height: 32.5,
  },
  investNowLayoutRight: {
    width: 'calc(100% - 280px)',
    flexGrow: 1,
    position: 'relative',
    overflow: 'auto',
    height: '100vh',
    '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
      backgroundColor: '#1EA59A',
      width: '0.6em',
      visibility: 'hidden',
      display: 'none',
    },
    '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
      borderRadius: 8,
      backgroundColor: theme.palette.warning.main,
      minHeight: 24,
      border: '1px solid #1EA59A',
      visibility: 'hidden',
      display: 'none',
    },
    '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
      backgroundColor: '#2B2B2B',
    },
    '@media (max-width: 1220px)': {
      width: 'calc(100% - 230px)',
    },
    '@media (max-width: 1024px)': {
      width: '100%',
      margin: 0,
      marginBottom: 0,
      height: 'calc(100vh - 230px)',
    },
    '@media (max-width: 767px)': {
      width: '100%',
      margin: 0,
      border: 0,
      borderRadius: 0,
      // height: 'calc(100% - 70px)',
      overflow: 'hidden overlay',
    },
  },
  investNowLRPopup: {
    width: 'calc(100% - 280px)',
    flexGrow: 1,
    position: 'relative',
    overflow: 'auto',
    height: 'calc(100vh - 20px)',
    // height: '100%',
    '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
      backgroundColor: '#1EA59A',
      width: '0.6em',
      visibility: 'hidden',
    },
    '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
      borderRadius: 8,
      backgroundColor: theme.palette.warning.main,
      minHeight: 24,
      border: '1px solid #1EA59A',
      visibility: 'hidden',
    },
    '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
      backgroundColor: '#2B2B2B',
    },
    '@media (max-width: 1220px)': {
      width: 'calc(100% - 230px)',
    },
    '@media (max-width: 1024px)': {
      width: '100%',
      margin: 0,
      marginBottom: 0,
      height: 'calc(100% - 230px)',
    },
    '@media (max-width: 767px)': {
      width: '100%',
      margin: 0,
      border: 0,
      borderRadius: 0,
      // height: 'calc(100% - 70px)',
      overflow: 'hidden overlay',
    },
  },
  closeIcon: {
    position: 'absolute',
    cursor: 'pointer',
    top: 12,
    right: 12,
    '&:hover': {
      background: 'transparent',
    },
  },
  investNowTextBox: {
    position: 'absolute',
    top: 12,
    right: 60,
    background: '#AED3FF',
    borderRadius: 20,
    padding: 12,
    marginBottom: 15,
    fontSize: 16,
    fontWeight: 600,
    letterSpacing: '0.3px',
    zIndex: 9,
  },
  // investNowLayoutRightBox: {
  //   height: '100%',
  //   overflow: 'auto',
  //   '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
  //     backgroundColor: '#1EA59A',
  //     width: '0.6em',
  //     visibility: 'hidden',
  //   },
  //   '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
  //     borderRadius: 8,
  //     backgroundColor: theme.palette.warning.main,
  //     minHeight: 24,
  //     border: '1px solid #1EA59A',
  //     visibility: 'hidden',
  //   },
  //   '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
  //     backgroundColor: '#2B2B2B',
  //   },
  // },
  // investNowLayoutRightCont: {
  //   padding: '40px 60px',
  //   overflow: 'hidden',
  //   '@media (max-width: 1024px)': {
  //     padding: '40px 5% 30px',
  //   },
  //   '@media (max-width: 767px)': {
  //     padding: '30px 5% 0px',
  //   },
  // },
  //////Invest Now Deal styling
  investDealBox: {
    padding: '0px 15px 15px',
  },
  investDealTxtBox: {
    marginBottom: 30,
    display: 'flex',
    alignItems: 'center',
  },
  investDealTxt: {
    fontSize: 18,
    fontWeight: 600,
    letterSpacing: '0.3px',
    fontFamily: theme.typography.fontFamily,
    paddingRight: 5,
  },
  selectBox: {
    width: 136,
    height: 36,
    border: '1px solid #CED4DA',
    borderRadius: 5,
    '& .MuiSelect-select.MuiSelect-select': {
      paddingLeft: 10,
    },
    '&::before': {
      borderBottom: 0,
      '& ::hover': {
        borderBottom: 0,
      },
    },
    '& .MuiSelect-icon': {
      top: 'calc(50% - 10px)',
      right: 8,
    },
  },
  continueBtnBox: {
    margin: 'auto',
    display: 'block',
    width: 152,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: 10,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    fontSize: 15,
    cursor: 'pointer',
    height: 58,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.contrastText,
    },
  },
}));
